export default __webpack_public_path__ + "static/media/MrMEOLA.10afdf30.mp4";